<template>
	<div class="tab-separator"></div>
</template>
<style lang="scss" scoped>
.tab-separator {
	align-self: center;
	margin: 0;
	padding: 0;
	width: 0.1rem;
	height: 4.8rem;
	background: $color-border;
}
</style>
